
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"10","height":"10","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9.083 1.74L8.261.916 5 4.177 1.74.918l-.823.822L4.177 5 .918 8.26l.822.823L5 5.823l3.26 3.26.823-.822L5.823 5z","fill-rule":"evenodd"}})])
      }
    
      }
    